import { TasksSubtabRouteParam } from './loanApplication';

export const TaskStatus = {
  SUBMITTED: 'Submitted',
  NEW: 'New',
  APPROVED: 'Approved',
  CANCELED: 'Canceled',
  REJECTED: 'Rejected',
  RETURNED: 'Returned',
};

// Who a TaskHistory entry is visible to — the string serialization of the SkynetCore
// TaskHistoryAudience enum (the API serializes enums as strings, matching TaskStatus above).
export const TaskHistoryAudience = {
  TO_PARTNER: 'ToPartner',
  TO_BORROWER: 'ToBorrower',
  INTERNAL_ONLY: 'InternalOnly',
};

export const TaskHistoryAudienceLabel = {
  [TaskHistoryAudience.TO_PARTNER]: 'To Partner',
  [TaskHistoryAudience.TO_BORROWER]: 'To Borrower',
  [TaskHistoryAudience.INTERNAL_ONLY]: 'Internal',
};

// Ordered so the safe default (Internal) is first in any audience picker.
export const taskHistoryAudienceOptions = [
  {
    name: TaskHistoryAudienceLabel[TaskHistoryAudience.INTERNAL_ONLY],
    value: TaskHistoryAudience.INTERNAL_ONLY,
  },
  {
    name: TaskHistoryAudienceLabel[TaskHistoryAudience.TO_PARTNER],
    value: TaskHistoryAudience.TO_PARTNER,
  },
  {
    name: TaskHistoryAudienceLabel[TaskHistoryAudience.TO_BORROWER],
    value: TaskHistoryAudience.TO_BORROWER,
  },
];

// An unset/omitted audience must never widen visibility, mirroring the API's InternalOnly default.
export const DEFAULT_TASK_HISTORY_AUDIENCE_OPTION = taskHistoryAudienceOptions.find(
  ({ value }) => value === TaskHistoryAudience.INTERNAL_ONLY,
);

// What kind of entry a TaskHistory row is; legacy rows may arrive with no entryKind at all.
export const TaskHistoryEntryKind = {
  STATUS_CHANGE: 'StatusChange',
  MESSAGE: 'Message',
  RETURN: 'Return',
};

// One-place surface partition (Return is both a status transition and a thread event); the
// table excludes rather than whitelists so legacy/unknown entryKinds stay visible.
export const THREAD_ENTRY_KINDS = [TaskHistoryEntryKind.MESSAGE, TaskHistoryEntryKind.RETURN];

export const STATUS_TABLE_HIDDEN_ENTRY_KINDS = [TaskHistoryEntryKind.MESSAGE];

export const TasksTabLabel = {
  PENDING: 'Pending',
  TO_REVIEW: 'Ops To Review',
  RETURNED: 'Returned',
  COMPLETED: 'Completed',
  REJECTED: 'Rejected',
  CANCELED: 'Canceled',
};

export const TaskStatusLabel = {
  [TaskStatus.SUBMITTED]: 'Submitted',
  [TaskStatus.NEW]: 'Created',
  [TaskStatus.APPROVED]: 'Approved',
  [TaskStatus.CANCELED]: 'Canceled',
  [TaskStatus.REJECTED]: 'Rejected',
  [TaskStatus.RETURNED]: 'Returned',
};

export const TabStatusRelation = {
  [TasksSubtabRouteParam.TO_REVIEW]: TaskStatus.SUBMITTED,
  [TasksSubtabRouteParam.PENDING]: TaskStatus.NEW,
  [TasksSubtabRouteParam.REJECTED]: TaskStatus.REJECTED,
  [TasksSubtabRouteParam.COMPLETED]: TaskStatus.APPROVED,
  [TasksSubtabRouteParam.CANCELED]: TaskStatus.CANCELED,
};

export const TaskStatusTabRelation = {
  [TaskStatus.SUBMITTED]: TasksTabLabel.TO_REVIEW,
  [TaskStatus.NEW]: TasksTabLabel.PENDING,
  [TaskStatus.RETURNED]: TasksTabLabel.RETURNED,
  [TaskStatus.REJECTED]: TasksTabLabel.REJECTED,
  [TaskStatus.APPROVED]: TasksTabLabel.COMPLETED,
  [TaskStatus.CANCELED]: TasksTabLabel.CANCELED,
};

export const TaskAssignmentType = {
  BORROWER: 'Borrower',
  SLA_GROUP: 'SlaGroup',
  SUB_COMPANY: 'SubCompany',
  SUB_COMPANY_USER: 'SubCompanyUser',
};

export const taskAssignmentTypeOptions = [
  { name: 'SLA Groups', value: TaskAssignmentType.SLA_GROUP },
  { name: 'Borrower', value: TaskAssignmentType.BORROWER },
  { name: 'Sub Company', value: TaskAssignmentType.SUB_COMPANY },
  { name: 'Sub Company User', value: TaskAssignmentType.SUB_COMPANY_USER },
];

export const TaskSignalREventType = {
  TASK_STATUS_CHANGED: 'TaskStatusChanged',
};

export const TaskAssignmentTypeLabel = {
  [TaskAssignmentType.BORROWER]: 'Borrower',
  [TaskAssignmentType.SLA_GROUP]: 'Internal',
  [TaskAssignmentType.SUB_COMPANY]: 'Sub Company',
  [TaskAssignmentType.SUB_COMPANY_USER]: 'Sub Company User',
};

export const MAX_FILES_COUNT_TO_UPLOAD = 15;

// BE-owned task type for the deferred TPO "Authorized Signer Participation" task
// (created by SetTpoApplicationSignersCommand when a non-signer submits a cert).
// The task carries metadata.certificationId and isSignatureRequired; its submit
// surface opens the embedded signing component instead of the acknowledgment modal.
export const AUTHORIZED_SIGNER_TASK_TYPE_ID = '3812dafe-0000-4a8b-9c10-3fe27a9d3812';
